<template>
  <div id="contenedor-perfil-usuario">
    <template v-if="soloImagen && !$apollo.loading">
      <v-tooltip
        top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-avatar
            v-bind="attrs"
            v-on="on"
            color="white"
            :size="40">
            <img :src="`${$urlFileServer}/${getDatosUsuario.avatarPublicKey}`">
          </v-avatar>
        </template>
        <span>
          {{ getusuarioNombre(getDatosUsuario) }}
        </span>
      </v-tooltip>
    </template>
    <template v-if="soloInfo && !$apollo.loading">
      <v-row justify="center">
        <template v-if="!getDatosUsuario.avatarPublicKey">
          <avatar
            tipo="nombre"
            :nombre="getUsuarioNombre(getDatosUsuario)"
            color="grey"
            :size="90"
            dark>
          </avatar>
        </template>
        <template v-else>
          <avatar
            tipo="imagen"
            :imgUrl="`${$urlFileServer}/${getDatosUsuario.avatarPublicKey}`"
            :size="90">
          </avatar>
        </template>
      </v-row>
      <v-row class="mt-2" justify="center">
        <h3> {{getUsuarioNombre(getDatosUsuario)}} </h3>
      </v-row>
      <v-row
        class="mb-4"
        justify="center">
        <!--<span> {{getDatosUsuario.funcionario.puesto}} </span>-->
      </v-row>
    </template>
    <template v-if="!soloInfo && !soloImagen">
      <v-card flat>
        <v-skeleton-loader
          v-if="$apollo.loading"
          type="table-heading, table-thead, table-tbody"
        ></v-skeleton-loader>
        <v-card-text
          class="mx-4"
          v-if="!$apollo.loading">
          <v-row justify="end">
            <v-menu
              v-model="mostrarMenuEditar"
              bottom
              rounded
              offset-y
              >
              <template
                v-slot:activator="{ on, attrs }">
                <v-btn
                class="mx-4"
                  icon
                  v-bind="attrs"
                  v-on="on">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <!--
                <v-list-item
                  @click="mostarActualizarDatos = true"
                  link>
                  <v-list-item-icon class="mx-2">
                    <v-icon>
                      mdi-account-edit
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Actualizar mis Datos
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                -->
                <v-list-item
                  @click="mostrarCambiarCorreo = true"
                  link>
                  <v-list-item-icon class="mx-2">
                    <v-icon>
                      mdi-email-edit
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Actualizar mi Correo
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  @click="mostrarAgregarImagen = true"
                  link>
                  <v-list-item-icon class="mx-2">
                    <v-icon>
                      mdi-camera
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ getDatosUsuario.avatarPublicKey
                      ? 'Actualizar Imagen'
                      : 'Agregar Imagen'}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  @click="mostrarCambiarPassword = true"
                  link>
                  <v-list-item-icon class="mx-2">
                    <v-icon>
                      mdi-key-variant
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      Cambiar Contraseña
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
          <v-row class="my-4" justify="space-between">
            <v-col cols="12" md="4" style="height:300px">
              <!-- si existe el avatar de usuario se muestra aqui -->
              <template
              v-if="getDatosUsuario.avatarPublicKey">
              <v-row justify="center">
                <avatar
                  tipo="imagen"
                  :imgUrl="`${$urlFileServer}/${getDatosUsuario.avatarPublicKey}`"
                  :size="300">
                </avatar>
              </v-row>
              </template>
              <!-- si no existe el avatar de usuario se muestra imagen generica -->
              <template
                v-else>
                <v-row justify="center" align="center" style="height:100%">
                  <v-img
                    src="@/assets/foto-perfil-default.png"
                    contain
                    height="300"
                    width="300">
                  </v-img>
                </v-row>
              </template>
            </v-col>
            <v-col cols="12" md="4">
              <v-row class="mb-2 mt-4" justify="start">
                <h1>{{getUsuarioNombre(getDatosUsuario)}}</h1>
              </v-row>
              <v-row class="mb-2" justify="start">
                <!--<h2> {{ getDatosUsuario.funcionario.puesto }} </h2>-->
              </v-row>
              <v-row class="mb-2" justify="start">
                <v-icon class="mr-2" small> mdi-calendar </v-icon>
                <h2>
                  Usuario desde: {{ new Date(getDatosUsuario.createdAt).toLocaleDateString() }}
                </h2>
              </v-row>
              <v-row class="mb-2" justify="start">
                <v-icon class="mr-2" small> mdi-email </v-icon>
                <h2> {{getDatosUsuario.correoElectronico}}</h2>
              </v-row>
              <v-row class="mb-2" justify="start">
                <v-icon class="mr-2" small> mdi-account-check </v-icon>
                <h2>Estatus: {{ getDatosUsuario.estatus === 1 ? 'Activo' : 'Inactivo' }}</h2>
              </v-row>
              <v-row>
                <v-icon class="mr-2" small> fa-hard-hat </v-icon>
                <!--
                <h2>
                  Supervisor de Obra: {{ getDatosUsuario.funcionario.esSupervisor ? 'Si' : 'No' }}
                </h2> -->
              </v-row>
            </v-col>
            <v-col>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <!-- Ventana para cambiar contraseña -->
    <v-dialog
      v-model="mostrarCambiarPassword"
      width="500">
      <cambiar-password
      v-if="mostrarCambiarPassword"
      :usuarioId="usuarioId"
      v-on:cerrar="cerrarVentana">
      </cambiar-password>
    </v-dialog>
    <!-- Ventana para actualizar correo electronico -->
    <v-dialog
      v-model="mostrarCambiarCorreo"
      width="500">
      <cambiar-correo
      v-if="mostrarCambiarCorreo"
      :usuarioId="usuarioId"
      v-on:cerrar="cerrarVentana">
      </cambiar-correo>
    </v-dialog>
    <!-- Ventana para actualizar datos del usuario -->
    <v-dialog
      v-model="mostarActualizarDatos"
      width="500">
      <actualizar-datos
      v-if="mostarActualizarDatos"
      :funcionarioId="getDatosUsuario.funcionario.id"
      v-on:cerrar="cerrarVentana">
      </actualizar-datos>
    </v-dialog>
    <!-- Ventana para agregar imagen de perfil a usuario -->
    <v-dialog
      v-model="mostrarAgregarImagen"
      width="500">
      <agregar-imagen
      v-if="mostrarAgregarImagen"
      :usuarioId="usuarioId"
      :datosUsuario="getDatosUsuario"
      v-on:cerrar="cerrarVentana">
      </agregar-imagen>
    </v-dialog>
  </div>
</template>

<script>
import USUARIO from '@/graphql/querys/administracion/catalogos/usuarios/usuario.gql';
import Avatar from '@/components/Avatar.vue';
import CambiarPassword from './CambiarPassword.vue';
import CambiarCorreo from './CambiarCorreo.vue';
import ActualizarDatos from '@/components/administracion/configuracion/catalogos/usuarios/ActualizarDatos.vue';
import AgregarImagen from '@/components/administracion/configuracion/catalogos/usuarios/AgregarImagen.vue';

export default {
  name: 'PerfilUsuario',
  props: {
    usuarioId: {
      type: String,
      required: true,
    },
    soloInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
    soloImagen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Avatar,
    CambiarPassword,
    CambiarCorreo,
    ActualizarDatos,
    AgregarImagen,
  },
  apollo: {
    usuario: {
      query: USUARIO,
      variables() {
        return {
          id: this.usuarioId,
        };
      },
    },
  },
  data() {
    return {
      avatarPublicKey: null,
      mostrarCambiarPassword: false,
      mostrarCambiarCorreo: false,
      mostarActualizarDatos: false,
      mostrarAgregarImagen: false,
      mostrarMenuEditar: false,
    };
  },
  methods: {
    cerrarVentana() {
      this.mostrarCambiarPassword = false;
      this.mostrarCambiarCorreo = false;
      this.mostarActualizarDatos = false;
      this.mostrarAgregarImagen = false;
    },
    cerrar() {
      this.$emit('cerrar');
    },
    getUsuarioNombre(usuario) {
      if (usuario.funcionario?.nombre) { return usuario.funcionario.nombre; }
      if (usuario.cliente?.nombre) { return usuario.cliente.nombre; }
      if (usuario.contratista?.nombreRazonSocial) { return usuario.contratista.nombreRazonSocial; }
      return '';
    },
  },
  computed: {
    getDatosUsuario() {
      if (!this.usuario) return {};
      return this.usuario;
    },

  },

};
</script>

<style>

</style>
